"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FromUrlInput;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIMedia = _interopRequireDefault(require("UIComponents/layout/UIMedia"));

var _UIMediaRight = _interopRequireDefault(require("UIComponents/layout/UIMediaRight"));

var _UIMediaBody = _interopRequireDefault(require("UIComponents/layout/UIMediaBody"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

function FromUrlInput(props) {
  var error = props.error,
      value = props.value,
      onKeyUp = props.onKeyUp,
      onChange = props.onChange,
      onPreview = props.onPreview;
  return _react.default.createElement(_UIMedia.default, null, _react.default.createElement(_UIMediaBody.default, null, _react.default.createElement(_UITextInput.default, {
    value: value,
    placeholder: _I18n.default.text('FileManagerLib.fromUrlPlaceholder'),
    error: !!error,
    onKeyUp: onKeyUp,
    onChange: onChange
  })), _react.default.createElement(_UIMediaRight.default, null, _react.default.createElement(_UIButton.default, {
    onClick: onPreview,
    use: "tertiary-light"
  }, _I18n.default.text('FileManagerLib.actions.preview'))));
}

FromUrlInput.propTypes = {
  error: _react.PropTypes.bool,
  value: _react.PropTypes.string.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  onKeyUp: _react.PropTypes.func.isRequired,
  onPreview: _react.PropTypes.func.isRequired
};
module.exports = exports.default;